// Angular
import { FormsModule } from "@angular/forms";
import { Component, inject, OnDestroy, OnInit, ViewChild } from "@angular/core";

// Ant
import { NzIconDirective } from "ng-zorro-antd/icon";
import { NzButtonComponent } from "ng-zorro-antd/button";
import { NzOptionComponent, NzSelectComponent } from "ng-zorro-antd/select";
import { NzModalComponent, NzModalContentDirective, NzModalModule } from "ng-zorro-antd/modal";

// Models
import { NavigationLayoutItemsList } from "#models/navigation";

// Components
import { NavigationBaseComponent } from "#components/navigation-base/navigation-base.component";

// Other
import { Subject, takeUntil } from "rxjs";
import { HotkeysService } from "@ngneat/hotkeys";
import { TranslatePipe } from "#pipes/translate/translate.pipe";

@Component({
    selector: "app-goto",
    imports: [
        FormsModule,
        NzModalModule,
        TranslatePipe,
        NzIconDirective,
        NzModalComponent,
        NzSelectComponent,
        NzOptionComponent,
        NzButtonComponent,
        NzModalContentDirective,
    ],
    styleUrl: "./goto.component.scss",
    templateUrl: "./goto.component.html",
})
export class GotoComponent extends NavigationBaseComponent implements OnInit, OnDestroy {
    @ViewChild(NzSelectComponent) nzSelect!: NzSelectComponent;

    //service
    private hotKeys = inject(HotkeysService);

    //variables
    selectedValue = "";
    isVisible = false;
    private destroy$ = new Subject<void>();

    ngOnInit(): void {
        this.hotKeys.removeShortcuts("shift.space");
        this.hotKeys
            .addShortcut({ keys: "shift.space", preventDefault: true })
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => this.toggleModal());
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    toggleModal() {
        this.isVisible = !this.isVisible;
        this.selectedValue = this.router.url.includes("type_id")
            ? this.router.url
            : `${this.router.url.split("?")[0]}`;

        setTimeout(() => {
            if (this.nzSelect) {
                this.nzSelect.focus();
                const renderedOptions = this.nzSelect.listOfNzOptionComponent.map(
                    (opt) => opt.nzValue
                );

                // Find the first option that starts with 'jack'
                const match = renderedOptions.find(
                    (opt) => typeof opt === "string" && opt.startsWith(this.selectedValue)
                );

                if (match) {
                    this.selectedValue = match; // Sync with the model
                }
            }
        }, 10);
    }

    async onChange(link: string) {
        this.toggleModal();
        let redirect = true;

        this.list.forEach((item) => {
            if (item.link === link && item.callback) {
                redirect = false;

                return item.callback();
            }
        });

        if (redirect) {
            await this.router.navigateByUrl(link);
        }
    }

    getLink(item: NavigationLayoutItemsList["children"][0]) {
        const queryParams = this.getQueryParamsForLink(item);
        const urlTree = this.router.createUrlTree([item.link], { queryParams });

        return this.router.serializeUrl(urlTree);
    }
}
